import { useRef } from 'react'
import { Indicator } from './styles'

export function clamp(n, min, max) {
	return Math.max(min, Math.min(max, n))
}

export function findColumnIdByCardId(board, cardId) {
	return board.columnOrder.find((colId) => board.columns[colId].cardIds.includes(cardId))
}

// ---------- smooth auto-scroll ----------
export function useAutoScroll() {
	const rafRef = useRef(null)
	const pointerRef = useRef({ x: 0, y: 0 })
	const ctxRef = useRef({ boardEl: null, columnsEls: [] })

	const start = ({ boardEl, columnsEls }) => {
		ctxRef.current = { boardEl, columnsEls }
		stop()

		const tick = () => {
			const { x, y } = pointerRef.current
			const { boardEl, columnsEls } = ctxRef.current

			// horizontal scroll for board
			if (boardEl) {
				const r = boardEl.getBoundingClientRect()
				const edge = 90
				const maxSpeed = 18

				const leftDist = x - r.left
				const rightDist = r.right - x

				let vx = 0
				if (leftDist < edge) vx = -maxSpeed * (1 - leftDist / edge)
				if (rightDist < edge) vx = maxSpeed * (1 - rightDist / edge)

				if (vx !== 0) boardEl.scrollLeft += vx
			}

			// vertical scroll for each column list
			;(columnsEls || []).forEach((colEl) => {
				if (!colEl) return
				const r = colEl.getBoundingClientRect()
				const edge = 75
				const maxSpeed = 16

				const topDist = y - r.top
				const bottomDist = r.bottom - y

				let vy = 0
				if (topDist < edge) vy = -maxSpeed * (1 - topDist / edge)
				if (bottomDist < edge) vy = maxSpeed * (1 - bottomDist / edge)

				if (vy !== 0) colEl.scrollTop += vy
			})

			rafRef.current = requestAnimationFrame(tick)
		}

		rafRef.current = requestAnimationFrame(tick)
	}

	const updatePointer = (x, y) => {
		pointerRef.current = { x, y }
	}

	const stop = () => {
		if (rafRef.current) cancelAnimationFrame(rafRef.current)
		rafRef.current = null
	}

	return { start, stop, updatePointer }
}

// ---------- search ----------

function normalize(v) {
	return String(v ?? '')
		.trim()
		.toLowerCase()
}

export const leadMatchesSearch = (card, q) => {
	const query = normalize(q)
	if (!query) return true

	const orgName = normalize(card?.organisation_name)
	const orgId = normalize(card?.organisation_id)
	const pan = normalize(card?.pan)
	const loc = normalize(card?.location)
	const status = normalize(card?.raw?.source)
	const mobile = normalize(card?.raw?.user_details?.mobile_number) 

	const catItems = Array.isArray(card?.category_items) ? card.category_items : []
	const catText = normalize(
		catItems
			.map((x) => x?.category_name || x?.commodity_name)
			.filter(Boolean)
			.join(', ')
	)

	return (
		orgName.includes(query) ||
		orgId.includes(query) ||
		pan.includes(query) ||
		loc.includes(query) ||
		catText.includes(query) ||
		status.includes(query) ||
		mobile.includes(query)
	)
}


export function DropIndicator({ show }) {
	return <Indicator $show={show} />
}
